import axios from 'axios';

const service = axios.create({
  // Use CRA proxy in development: requests to '/api/...' will be proxied to backend
  baseURL: process.env.REACT_APP_BASE_API || '/api',
  timeout: 10000
});

// request interceptor
service.interceptors.request.use(
  config => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    console.log(error);
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  response => response.data,
  async error => {
    const originalRequest = error.config;

    // 🔐 access token이 만료됐고, 아직 재시도 전이라면
    if (
      error.response?.status === 401 &&
      !originalRequest._retry &&
      localStorage.getItem('refresh_token')
    ) {
      originalRequest._retry = true;

      try {
        // ✅ refresh token으로 새로운 access token 요청
        const res = await axios.post(
          `${process.env.REACT_APP_BASE_API}/kr/login/refresh-token`,
          { refresh_token: localStorage.getItem('refresh_token') }
        );

        const newAccessToken = res.data.access_token;
        localStorage.setItem('access_token', newAccessToken);

        // ✅ 헤더에 새 토큰 설정 후 재요청
        originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
        return service(originalRequest); // 재요청
      } catch (refreshErr) {
        console.error('Refresh Token 만료. 로그아웃합니다.');

        // 🔐 로그아웃 처리
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        window.location.href = '/login'; // 로그인 페이지로 이동
      }
    }

    return Promise.reject(error);
  }
);

export default service;
